import React, { createContext, useRef, useState } from 'react'

export const GoogleAdContext = createContext()

export const GoogleAdProvider = ({ children }) => {
  const pushedAds = useRef(new Set())
  const [previousRoute, setPreviousRoute] = useState(null)
  const [adsRequestSent, setAdsRequestSent] = useState(false)

  const sendAdsRequest = () => {
    console.log('Page Loaded, sending Ads Request...')
    ;(window.adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 0
    setAdsRequestSent(true)
  }

  return (
    <GoogleAdContext.Provider value={{ pushedAds, previousRoute, setPreviousRoute, sendAdsRequest, adsRequestSent, setAdsRequestSent }}>
      {children}
    </GoogleAdContext.Provider>
  )
}
